// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"2bb0c878","893":"df3739c7"}[chunkId] + ".chunk.js";
};